import {Component, Input, signal, SimpleChanges} from '@angular/core';
import {Utils} from '../../../../shared/utils';
import {NbDialogService, NbPopoverModule} from '@nebular/theme';
import {TeamDetailsComponent} from "../../../../shared/components/team-details/team-details.component";
import {TranslateModule} from '@ngx-translate/core';

@Component({
  selector: 'app-teams-list',
  standalone: true,
  imports: [
    TranslateModule,NbPopoverModule],
  templateUrl: './teams-list.component.html',
  styleUrl: './teams-list.component.scss'
})
export class TeamsListComponent {
  isData = signal<boolean>(false);
  @Input() teams: any[] = [];
  @Input() isLoggedIn!: boolean;

  constructor(public utils: Utils, private dialogService: NbDialogService) {}

  ngOnChanges(changes: SimpleChanges): void {
    this.isData.set(this.teams.length > 0)
  }

  open(team: any) {
    // if (this.isLoggedIn) {
      this.dialogService.open(TeamDetailsComponent, {
        dialogClass: 'popup',
        context: {
          team: team
        },
      });
    // }
  }

  close(){
    //this.dialogRef.close();
  }
}
